import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import RouteComponent from '../components/route.component';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { routes } from '../../../../../redux/route-management/routes/action';
import { selectRoutesQueryItems } from '../../../../../redux/route-management/routes/selector';
import { regions } from '../../../../../redux/route-management/regions/action';
import { selectRegionsListItems } from '../../../../../redux/route-management/regions/selector';
import PageLoader from '../../../../../components/PageLoader';



const ManagementRoute = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const routeQuery = useSelector(selectRoutesQueryItems)
  const regionListItems = useSelector(selectRegionsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedRoute,
    setSelectedRoute
  ] = useState<any>([])


  const fetchRouteById = () => {
    dispatch(routes.query({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/routes/query`, entity: 'routes', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(()=>{
      setIsLoading(false)
    })

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedRoute({ ...selectedRoute, [field]: event });
  }

  useEffect(
    () => {
      dispatch(regions.list({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/regions/list`, entity: 'regions', jsonData: {

        }
      })).then(()=>{
      if (parmas?.id > 0) {
        fetchRouteById()
        setIsLoading(false)
      }else {
        setIsLoading(false)
      }
    })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedRoute(routeQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      dispatch(routes.update({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/routes`, entity: 'routes', jsonData: {

          Records: [
            selectedRoute
          ]

        }
      })).then(()=>{
        back()
      })

    } else {
      dispatch(routes.create({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/routes`, entity: 'routes', jsonData: {

          Records: [
            selectedRoute
          ]

        }
      })).then(()=>{
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/route-management/routes')
  }

  return (
    <>
    {isLoading ? <PageLoader /> : 
      <RouteComponent
        handleInnerFormChange={handleInnerFormChange}
        regions={regionListItems?.result?.items}
        selectedRoute={selectedRoute}
        back={back}
        handleFormSubmit={handleFormSubmit}
      />
    }
    </>
  )

}

export default ManagementRoute;